import { useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  useEffect(() => {
    const handleHashClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href^="#"]');
      if (!anchor) return;
      const href = anchor.getAttribute('href');
      if (!href) return;
      e.preventDefault();
      const el = document.querySelector(href);
      if (el) {
        const top = el.getBoundingClientRect().top + window.pageYOffset - 72;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    };

    document.addEventListener('click', handleHashClick);
    return () => document.removeEventListener('click', handleHashClick);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <HeroSection />
        <AppSection />
        <CommentsSection />
        <FeaturesSection />
        <AboutSection />
        <CarouselSection />
        <IndexSection />
        <FaqSection />
        <CardsSection />
        <TopicsSection />
        <MediaSection />
        <UpdatesSection />
        <ContactSection />
        <RankingSection />
      </main>

      <Footer />
    </div>
  );
}